import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { updateProfile } from '../services/api/userApi';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = ({ show, onHide }) => {
  const { user, refreshUser } = useAuth();
  const [firstName, setFirstName] = useState(user?.attributes?.given_name || '');
  const [lastName, setLastName] = useState(user?.attributes?.family_name || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const originalFirstName = user?.attributes?.given_name || '';
  const originalLastName = user?.attributes?.family_name || '';
  const hasChanges = firstName !== originalFirstName || lastName !== originalLastName;

  // Reset form when modal opens
  React.useEffect(() => {
    if (show) {
      setFirstName(user?.attributes?.given_name || '');
      setLastName(user?.attributes?.family_name || '');
      setError('');
      setSuccess('');
    }
  }, [show, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await updateProfile({
        id: 0, // Backend should ignore this and use current user's ID
        username: user.username || user.attributes?.email || '',
        email: user.attributes?.email || '',
        firstName,
        lastName
      });
      setSuccess('Profile updated successfully');
      // Refresh user data to update the display name
      await refreshUser();
      // Close modal after successful update
      setTimeout(() => onHide(), 1000);
    } catch (error) {
      setError('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Manage Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </Form.Group>
          
          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onHide} className="me-2">
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={loading || !hasChanges}>
              {loading ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UserProfile;